module.exports = __webpack_public_path__ + "img/banner-1-m.985bcab9.jpg";